export default __webpack_public_path__ + "static/Bom-2024_logo_Sign-17f4683f42671769e5b386f5de806960.webp";